import clsx from 'clsx';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';

interface IProps {
  text: string;
  isSelected?: boolean;
  isCompleted?: boolean;
  className?: string;
}

const AccountSetupListItemNumber = (props: IProps) => {
  const { text, isSelected = false, className, isCompleted } = props;
  const baseClassName = `min-h-40 h-40 min-w-40 w-40 rounded-8 flex flex-col justify-center items-center font-600 ${className}`;
  const activeClassName = clsx(
    baseClassName,
    isSelected ? 'bg-[#4F46E5]' : 'bg-white bg-opacity-20',
  );

  return (
    <div className={activeClassName}>
      {isCompleted ? <FuseSvgIcon>material-solid:done</FuseSvgIcon> : text}
    </div>
  );
};

export default AccountSetupListItemNumber;
